export enum TabAnchor {
  ALL = '',
  PRODUCTS = '#products',
  CATEGORIES = '#categories',
  BRANDS = '#brands',
  STORES = '#stores',
}
